import api from './api';

// Talks to /api/work-center-costing — the four captured costing parameters.
// Volume (bud_production_volumes) and batch size (bud_bom_items) come back on
// the GET as read-only inputs; everything else the page derives.
export const workCenterCostingService = {
  // { centers, routing, items }
  getCosting: async () => {
    const res = await api.get('/work-center-costing');
    return res.data;
  },

  // payload: { centers: [{ code, setup_rate, run_rate }],
  //            routing: [{ work_center_code, stock_code, setup_time, run_time }] }
  saveCosting: async (payload) => {
    const res = await api.put('/work-center-costing', payload);
    return res.data;
  },

  // Drop an item's override so it falls back to the work centre's default.
  deleteRouting: async (workCenterCode, stockCode) => {
    const res = await api.delete('/work-center-costing', {
      data: { work_center_code: workCenterCode, stock_code: stockCode },
    });
    return res.data;
  },
};

export default workCenterCostingService;
